import type { IconNode } from '../types';

/**
 * @name feather-text
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTcuOSA4SDkuMiIgLz4KICA8cGF0aCBkPSJNNS4xIDEySDE0bDgtOC4yYy0yLjMtMi4zLTYuMS0yLjMtOC41IDBMMiAxNSIgLz4KICA8cGF0aCBkPSJNMiAxOWg4IiAvPgogIDxwYXRoIGQ9Ik0yMSAxN3YxYzAgMSAxIDEuNSAxIDIuNSAwIC44LS43IDEuNS0xLjUgMS41aC01Yy0uOCAwLTEuNS0uNy0xLjUtMS41IDAtMSAxLTEuNSAxLTIuNXYtMSIgLz4KICA8cGF0aCBkPSJNMTQgMTdoOCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/feather-text
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const featherText: IconNode = [
  ['path', { d: 'M17.9 8H9.2', key: '12z0s4' }],
  ['path', { d: 'M5.1 12H14l8-8.2c-2.3-2.3-6.1-2.3-8.5 0L2 15', key: 'nyu28f' }],
  ['path', { d: 'M2 19h8', key: 'd1pspp' }],
  [
    'path',
    {
      d: 'M21 17v1c0 1 1 1.5 1 2.5 0 .8-.7 1.5-1.5 1.5h-5c-.8 0-1.5-.7-1.5-1.5 0-1 1-1.5 1-2.5v-1',
      key: '1lgmxf',
    },
  ],
  ['path', { d: 'M14 17h8', key: 'z0t944' }],
];

export default featherText;
